
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Repeater from "@/components/Reusable/CustomInputs/Repeater/Repeater.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import { PostChooserOptions } from "@/types/post-chooser";

const DEFAULT_CHOOSER_OPTIONS = {
  multiple: false,
  showThumbnails: false,
  postType: "post"
};

@Component({
  components: { TextInput, DropdownInput, Repeater }
})
export default class ElementStudioMediaOptions extends Vue {
  @Prop()
  value!: PostChooserOptions;

  get internalValue() {
    return this.value || DEFAULT_CHOOSER_OPTIONS;
  }

  updateMultiple(multiple: boolean) {
    this.emit({
      ...this.internalValue,
      multiple
    });
  }

  update(field: string, value: string | null) {
    this.emit({
      ...this.internalValue,
      [field]: value ?? ""
    });
  }

  emit(options: PostChooserOptions) {
    this.$emit("input", options);
  }
}
